import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { AuthService } from './core/services/auth.service';
import { CommunicationService } from './shared/services/communication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  sidebarMinimized = false;
  title = 'infobac-front-admin';
  rootSubscription: Subscription;

  constructor(
    private communicationService: CommunicationService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.changeSideBarStatus();
  }

  changeSideBarStatus() {
    this.rootSubscription = this.communicationService.getSideBarStatus().subscribe(data => {
      this.sidebarMinimized = data;
    });
  }

  userAuth() {
    return this.authService.getUserState();
  }

  ngOnDestroy() {
    this.rootSubscription.unsubscribe();
  }
}
